import React, { useState } from 'react';
import '../styles/Navbar.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);

  };
  
  const handleLogoClick = () => {
    navigate('/');
  };
  
    
  return (
    <nav className="navbar">
      <img className='logo' src="./slogo.png" alt="logo"  onClick={handleLogoClick}/>
      
      {/* Hamburger Menu Icon */}
      <div className="hamburger" onClick={toggleMenu}>
        ☰
      </div>
      
      <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
        <li><Link to="/" onClick={() => setIsOpen(false)}>Home</Link></li>
        <li><Link to="/products" onClick={() => setIsOpen(false)}>Products</Link></li>
        <li><Link to="/about" onClick={() => setIsOpen(false)}>About Us</Link></li>
        <li><Link to="/facilities" onClick={() => setIsOpen(false)}>Facilities</Link></li>
        <li><Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;
